import type { AnalyticDateFilter } from '~/presentation/ui';

import { getPeriodChartName } from '../modules/analytic/helpers/chart';

interface UsePAAnalyticIntervalProps {
  currentDates: AnalyticDateFilter;
  previousDates: AnalyticDateFilter;
}
export const usePAAnalyticLineChart = ({
  currentDates,
  previousDates,
}: UsePAAnalyticIntervalProps) => {
  const currentPeriodChartName = getPeriodChartName(currentDates);
  const previousPeriodChartName = getPeriodChartName(previousDates);

  return {
    currentPeriodChartName,
    previousPeriodChartName,
  };
};
